import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notification__head" }
const _hoisted_2 = { class: "notification__title" }
const _hoisted_3 = { class: "notification__date" }
const _hoisted_4 = { class: "notification__content" }

import {NotificationEntity} from "@/entities/NotificationEntity";
import "./Notification.scss";
import {computed} from "vue";
import moment from "moment";
import Icon from "@/components/Icon/Icon.vue";

interface Props{
	notification : NotificationEntity
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    notification: {}
  },
  setup(__props: any) {

let props = __props;

let data = computed<any>(() => {
	return props.notification.data;
});

let title = computed<string>(() => {
	return data.value.emotion === 'success' ? 'Successful' : 'Unsuccessful';
});

let date = computed<string>(() => {
	return moment(props.notification.created_at).format('DD.MM.YYYY HH:mm');
});

let content = computed<string>(() => {

	switch(data.value.type){

		case 'WithdrawalSuccess':
			return `Withdrawal of ${data.value.amount} USDT completed.`

		case 'WithdrawalFailed':
			return `Check your wallet address and try again.`;

		case 'DepositSuccess':
			return `Deposit of ${data.value.amount} USDT completed.`

		default:
			return '';

	}

});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["notification card", `notification--${ _unref(data).emotion }`])
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["notification__icon", `notification__icon--${ _unref(data).emotion }`])
    }, [
      (_unref(data).emotion === 'success')
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            name: "check"
          }))
        : _createCommentVNode("", true),
      (_unref(data).emotion === 'failed')
        ? (_openBlock(), _createBlock(Icon, {
            key: 1,
            name: "close"
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(title)) + ":", 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(date)), 1)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(content)), 1)
  ], 2))
}
}

})